import { isNaN } from 'volta/utils/math-utils';

import { helper } from '@ember/component/helper';

function isNanHelper([nb]: [number]) {
  return isNaN(nb);
}
export default helper(isNanHelper);
